import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/_public/customer/locations/$locationId/electrical/projects/$projectId/_details/_reports/distribution-boards/$distributionId/notifications/',
)({
    component: RouteComponent,
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/customer/locations/$locationId/electrical/projects/$projectId/distribution-boards/$distributionId', params });
    },
});

function RouteComponent() {
    return null;
}
